import React from 'react';
import Button from "components/button";
import { connect } from "react-redux";
import { EditOutlined, RollbackOutlined, SaveOutlined } from '@ant-design/icons';
import { removeActiveModal } from '../../redux/layout/layoutState';
import { useCRUDAccess } from "utils/useCRUDAccess";

function CrudButtons(props) {
  	const { baseRoute, mode, recordId, doHideModal, backUrl, cancelUrl, 
		withBack=true, 
		withEdit=true, 
		isModal=false, 
		modalId,
		submitLabel, 
		backLabel='Back', 
		cancelLabel='Cancel', 		
		updateLabel='Update', 
		createLabel='Save',
		hideWithRedux,
		moduleId,
		...rest } = props;
		
	const checkCRUDAccess = useCRUDAccess();

  	return (
		<div className="w-full flex gap-4 justify-end text-right my-3" {...rest}> 			
 			{mode === 'view' ? 
			<>
				{withBack && 				
				<Button 
					type="button" 
					className="crud-button" 
					href={backUrl ?? baseRoute}
				>
					{backLabel}
				</Button>
				}
				{(checkCRUDAccess(moduleId, 'edit') &&  withEdit) && 
				<Button 
					className="crud-button"
					type="button" 
					onClick={props.onEditClick ?? (() => {
						window.location.href = `${baseRoute}/${recordId}/edit`;
					})}
				>
					<div className="flex items-center gap-1">
						<EditOutlined className='me-1' />
						<span>Edit</span>
					</div>
				</Button>
				}      			
	    	</>
 			: 
			<>
				{isModal ?
					<Button 
						className="crud-button"
						type="button" 
						key="cancel" 
						onClick={() => {
							if (typeof doHideModal === "function") {
								doHideModal();
							} else {
								hideWithRedux?.(modalId);
							}
						}}
					>
						<RollbackOutlined className='me-1'/>
						{cancelLabel}
					</Button>
					: <Button 
						className="crud-button"
						href={cancelUrl ?? baseRoute}>
						<RollbackOutlined className='me-1'/>
						{cancelLabel}
					</Button>
				}
				{checkCRUDAccess(moduleId, recordId > 0 ? 'edit' : 'add') &&
	            <Button 
					type="submit" 
					className="crud-button"
				>
					<SaveOutlined className='me-1' />
	      			{submitLabel != null ? submitLabel : (recordId > 0 ? updateLabel : createLabel)}
	    		</Button>
				}
    		</>			 
 			}
        </div>
  	);
}

const mapStateToProps = (state) => ({	
});

const mapDispatchToProps = (dispatch) => ({
  	hideWithRedux: (id) => dispatch(removeActiveModal(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CrudButtons);